import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ImageHero } from '@components/image-hero/models';
import { ImageComponent } from '@shared/components/image';

@Component({
  selector: 'app-image-hero',
  templateUrl: './image-hero.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent],
})
export class ImageHeroComponent extends AbstractDynamicComponent<ImageHero> {}
